module.exports = __webpack_public_path__ + "img/qualities-bg2.0bdb7636.png";